import { LEPC_IDS } from "../../../constants";
import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "East Baton Rouge Portal": {
    parameters: {
      linkUrls: [
        "https://www.brla.gov/formcenter/mayors-office-of-homeland-security-emergency-preparedness-7/tier-ii-report-151",
      ],
      staffInputs: {
        documentTypes: {
          submission: true,
        },
      },
      includeLepcs: [
        {
          id: LEPC_IDS.LA.EAST_BATON_ROUGE,
          name: "East Baton Rouge Parish EPC",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "LA",
    dependsOn: ["Prior Activity"],
  },
  "Louisiana Invoice": {
    parameters: {
      linkUrls: ["https://rtkweb.dps.la.gov/t2access.nsf"],
      staffInputs: {
        fees: true,
        documentTypes: {
          invoice: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Invoice",
    consolidated: "Once Per Organization",
    state: "LA",
  },
  "Rapides Parish EPC Fees": {
    parameters: {
      linkUrls: ["https://www.notion.so/encamp/Rapides-Parish-b8a7567d5f4c4bbd916df713bf1a3a97"],
      staffInputs: {
        fees: true,
        documentTypes: {
          invoice: true,
        },
      },
      includeLepcs: [
        {
          id: LEPC_IDS.LA.RAPIDES_PARISH,
          name: "Rapides Parish EPC",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Invoice",
    state: "LA",
    dependsOn: ["Prior Activity"],
  },
  "Louisiana Portal Newly Not Reporting": {
    parameters: {
      staffInputs: {
        documentTypes: {
          proof: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Portal",
    state: "LA",
  },
};
